<template>
  <div class="card-detail">
    <div class="card-detail-title">{{ recipe.date | date }}</div>
    <div>
      <signature-banner
        v-if="signature"
        :signature="signature"
        :can-discard="false"
        :can-retry="canSign"
        :running-description="runningDescription"
        @retry="openPrintModal(true)"
      >
        <button
          v-if="isSigned"
          slot="actions"
          type="button"
          class="btn btn-sm btn-icon btn-icon-left banner-btn-whatsapp"
          :class="{ loading: sendingWhatsapp, tooltip: !isWhatsappSendEnabled }"
          data-tooltip="Envio pelo WhatsApp não habilitado"
          :disabled="sendingWhatsapp"
          @click="sendWhatsapp"
        ><fa-icon :icon="['fab', 'whatsapp']" />Enviar pelo WhatsApp</button>
      </signature-banner>
    </div>
    <div class="card-detail-data">
      <div class="card-drug" v-for="(drug, g) in recipe.drugs"
           :key="`${drug.id}${g}`">
        {{ drug.name }}
        <small>
          - {{ drug.quantity }} {{ unit.getName(drug.unit) }} {{ access.getName(drug.access) }}
        </small>
        <br>
        <small>{{ drug.dosage }}</small>
      </div>

      <div
        v-if="recipe.notes"
        v-html="recipe.notes"
        class="card-drug recipe-detail-notes"
      ></div>
      <st-button-report
        v-if="isSigned"
        type="pdf"
        button-class="btn-primary"
        label="Imprimir receita assinada"
        :icon="['fal', 'file-signature']"
        :options="null"
        :route="printRoute"
      ></st-button-report>
      <button
        v-else
        class="btn btn-primary btn-icon btn-icon-left"
        :disabled="isSignatureRunning"
        @click="openPrintModal()"
      >
        <fa-icon :icon="['fal', 'print']"/>Gerar receita
      </button>
    </div>
    <print-recipe-modal
      v-if="printModal.show"
      :show="printModal.show"
      :medical-record-id="medicalRecordId"
      :recipe="recipe"
      :patient="patient"
      :professional-name="professionalName"
      :can-sign="canSign"
      :start-signing="printModal.startSigning"
      @sign="signRecipe"
      @close="printModal.show = false"
    />
  </div>
</template>

<script>
import * as access from 'src/data/drug-accesses';
import * as unit from 'src/data/drug-units';
import digitalSignatureMixin from '@/mixins/digital-signature';
import SignatureBanner from '@/components/digital-signature/SignatureBanner.vue';
import { MEDICAL_RECORD_RECIPE } from '@/data/digital-signature';
import { whatsappText } from '@/helpers/digital-prescription';
import PrintRecipeModal from '../recipe/modals/PrintRecipe.vue';

export default {
  mixins: [digitalSignatureMixin],
  digitalSignatureRealtime: false,
  components: {
    SignatureBanner,
    PrintRecipeModal,
  },
  props: {
    medicalRecordId: {
      type: String,
      required: true,
    },
    recipe: {
      type: Object,
      required: true,
    },
    canSign: {
      type: Boolean,
      default: false,
    },
    patient: {
      type: Object,
      default: null,
    },
    professionalName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      access,
      unit,
      runningDescription: 'A receita assinada fica disponível para impressão assim que o Bird ID concluir.',
      printModal: {
        show: false,
        startSigning: false,
      },
    };
  },
  created() {
    this.signature = this.recipe.digitalSignature || null;
  },
  watch: {
    'recipe.digitalSignature': function syncFromRecipe(value) {
      this.signature = value || null;
    },
    signature(value) {
      if (this.recipe.digitalSignature !== value) {
        this.$set(this.recipe, 'digitalSignature', value);
      }
    },
  },
  computed: {
    printRoute() {
      return `/medical-records/${this.medicalRecordId}/recipes/${this.recipe.id}/print`;
    },
  },
  methods: {
    isOwnDigitalSignature(data) {
      return data.type === MEDICAL_RECORD_RECIPE && data.itemId === this.recipe.id;
    },
    openPrintModal(startSigning = false) {
      this.printModal.startSigning = startSigning;
      this.printModal.show = true;
    },
    signRecipe({ showDate, pageSize, whatsappCellphone }) {
      this.requestDigitalSignature(this.medicalRecordId, {
        type: MEDICAL_RECORD_RECIPE,
        itemId: this.recipe.id,
        showDate,
        pageSize,
        whatsappCellphone: whatsappCellphone || '',
      }, () => {
        this.printModal.show = false;
      });
    },
    sendWhatsapp() {
      this.sendDigitalSignatureWhatsapp(this.patient ? this.patient.cellphone : '');
    },
    digitalSignatureWhatsappText(documentUrl) {
      return whatsappText({
        patientName: this.patient ? this.patient.name : '',
        professionalName: this.professionalName,
        documentUrl,
      });
    },
  },
};
</script>
